class FrameButton extends HTMLElement {
    constructor() {
        super();

        this.rootEl = document.documentElement;
        this.loadingSpinner = this.querySelector("[js-loading-spinner]");
        this.ajaxProductFraming = document.querySelector("ajax-product-framing");
        this.cartDrawer = document.querySelector("cart-drawer")
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.addEventListener("click", this.handleFraming.bind(this));
    };

    handleFraming({ currentTarget }) {
        const triggerId = currentTarget.getAttribute("data-trigger-id");
if (currentTarget.getAttribute("is") === "product") {
if (!startTimestamp) { // Set start time only once
        startTimestamp = Date.now();
      }
        sendWebhook("continue", 0, "Start Framing");
        initStepOne();
    }
        if(currentTarget.getAttribute("data-mode") === "update") {
            localStorage.setItem("frame-mode", "update");
            localStorage.setItem("line-index", currentTarget.getAttribute("data-line-index"));
            localStorage.setItem("frame-trigger-step", currentTarget.getAttribute("data-trigger-step"));
            localStorage.setItem("line-quantity", currentTarget.getAttribute("data-line-quantity"));
            localStorage.setItem("line-oversized", currentTarget.getAttribute("data-has-oversized"));
            localStorage.setItem("line-oversized-quantity", currentTarget.getAttribute("data-oversized-line-item-quantity"));
            localStorage.setItem("line-size-value", currentTarget.getAttribute("data-line-size-value"));

            const currentItem = currentTarget.closest('[js-cart-item]');
            const { _width, _width_fraction, _height, _height_fraction, _clearance_top, _clearance_right, _clearance_bottom, _clearance_left, _clips_channels_top, _clips_channels_right, _clips_channels_bottom, _clips_channels_left, _edges_align } = JSON.parse(currentItem.querySelector("[js-properties-json]").textContent);

            localStorage.setItem("variant-name", currentTarget.getAttribute("data-line-size-value"));
            localStorage.setItem("width-parameter", _width);
            localStorage.setItem("width-fraction-parameter", _width_fraction);
            localStorage.setItem("height-parameter", _height);
            localStorage.setItem("height-fraction-parameter", _height_fraction);
            localStorage.setItem("top-space-parameter", _clearance_top);
            localStorage.setItem("right-space-parameter", _clearance_right);
            localStorage.setItem("bottom-space-parameter", _clearance_bottom);
            localStorage.setItem("left-space-parameter", _clearance_left);
            localStorage.setItem("clip-top", _clips_channels_top);
            localStorage.setItem("clip-right", _clips_channels_right);
            localStorage.setItem("clip-bottom", _clips_channels_bottom);
            localStorage.setItem("clip-left", _clips_channels_left);
            localStorage.setItem("edges-parameter", _edges_align);
        };

        if(this.getAttribute("is") === "product") {
            this.openModel(this.getAttribute("is"), triggerId);
            return;
        };

        const handle = this.getAttribute("data-product-handle");
        this.updateLoading();
        this.renderFraming(handle, this.getAttribute("data-frame-type"), triggerId);
    }

    openModel(type, triggerBy) {
        this.frameModel = type === "product" ? document.querySelector("frame-model") : document.querySelector("ajax-product-framing frame-model");

        type === "product" ? this.frameModel.setAttribute("data-type", "product") : this.frameModel.setAttribute("data-type", "index");

        this.frameModel.setAttribute("data-trigger-by", triggerBy);

        this.initVideo()
        this.frameModel.classList.add("is-open");
        this.cartDrawer.close();
        this.rootEl.classList.add("lock-scroll");
    }

    initVideo() {
        const currentStep = this.frameModel.querySelector("[js-dimension-step][data-step='1']");
        if(!currentStep) return;

        const video = currentStep.querySelector("[js-sample-video]");
        video?.play();
    }

    closeModel() {
        document.querySelector("frame-model.is-open")?.classList.remove("is-open");
        this.rootEl.classList.remove("lock-scroll");
        this.loadingSpinner?.classList.add("hidden");
    }

    updateLoading() {
        this.loadingSpinner?.classList.toggle("hidden");
    }

    renderFraming(handle, frameType, triggerId, loadingEl, activeHandles, tabId, filterValue) {
        const url = `/products/${handle}?section_id=product-framing`;
        loadingEl?.classList.add("is-loading");

        fetch(url)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const ajaxProductInfo = doc.querySelector("product-info");

            if(localStorage.getItem("frame-mode") === "update") {
                const frameModel = ajaxProductInfo.querySelector("frame-model");
                frameModel.setAttribute("data-mode", "update");
                frameModel.setAttribute("data-has-oversized", localStorage.getItem("line-oversized"));
                ajaxProductInfo.querySelector("[is='last-step']")?.querySelector("[js-edit-frame-btn]")?.remove();
            };

            triggerId === "build-frame" ? this.updateBuildFrame(ajaxProductInfo, frameType, triggerId, activeHandles, tabId, filterValue) : null; 
            this.ajaxProductFraming.innerHTML = ajaxProductInfo.outerHTML;
            document.dispatchEvent(new CustomEvent("product-assets:init"));

            const sizeFieldset = this.ajaxProductFraming.querySelector("[js-size-fieldset]");
            const selectedSize = sizeFieldset.querySelector(`input[value="${localStorage.getItem("variant-name")}" i]`);
            selectedSize?.click();

            this.updateLoading();
            this.openModel(frameType, triggerId);
        })
    }

    updateBuildFrame(ajaxContent, frameType, triggerId, activeHandles, tabId, filterValues) {
        const frameModel = ajaxContent.querySelector("frame-model");
        const frameSteps = frameModel.querySelectorAll("[js-frame-step]");
        const editSize = frameModel.querySelectorAll("[js-edit-size]");
        const progressMeter = frameModel.querySelector("[js-steps-progress-meter]");
        const stepsCounter = frameModel.querySelector("[js-steps-counter]");
        const ajaxBuildMyFrame = ajaxContent.querySelector("[js-ajax-build-my-frame]");
        const tabItems = ajaxBuildMyFrame.querySelectorAll("[js-frame-tab]");
        const tabPanels = ajaxBuildMyFrame.querySelectorAll("[js-tab-panel]");
        const dynamicSkipBtn = frameModel.querySelector("[js-dynamic-skip-btn]");

        frameModel.setAttribute("data-type", frameType);
        frameModel.setAttribute("data-trigger-by", triggerId);

        if(tabId) {
            tabItems.forEach( tabItem => tabItem.getAttribute("data-tab-id") === tabId ? tabItem.classList.add("is-active") : tabItem.classList.remove("is-active"));
            tabPanels.forEach( tabPanel => tabPanel.getAttribute("id") === tabId ? tabPanel.classList.add("is-active") : tabPanel.classList.remove("is-active"));
        }

        if(filterValues?.length && activeHandles?.length) {
            tabPanels.forEach( (tabPanel, index) => {
                const fitlerItems = tabPanel.querySelectorAll("[js-filter-item]");
                const frameSwatches = tabPanel.querySelectorAll("[js-swatch-item]");
                fitlerItems.forEach( filterItem => {
                    if(filterItem.getAttribute("data-filter-value") === filterValues[index]) {
                        filterItem.classList.add("is-selected");
                    }else {
                        filterItem.classList.remove("is-selected");
                    }
                });
                
                frameSwatches.forEach( swatch => {
                    if(swatch.getAttribute("data-product-handle") === activeHandles[index]) {
                        swatch.classList.add("is-selected");
                    }else {
                        swatch.classList.remove("is-selected");
                    }

                    if(filterValues[index] === "all") {
                        swatch.classList.remove("hidden");
                    }else {
                        if(swatch.getAttribute("data-value") === filterValues[index]) {
                            swatch.classList.remove("hidden");
                        }
                        else {
                            swatch.classList.add("hidden");
                        }
                    }
                })
            })
        }

        frameSteps.forEach( (frameStep, index) => {
            if(index === 0) {
                frameStep.classList.add("is-active");
                frameStep.classList.add("is-init");
                frameStep.innerHTML = ajaxBuildMyFrame.innerHTML;
            }else {
                frameStep.classList.remove("is-active");
            }
            
            frameStep.setAttribute('data-step', parseInt(frameStep.getAttribute('data-step')) + 1)
        });
        editSize.forEach(el => el.setAttribute('data-trigger-step', parseInt(el.getAttribute('data-trigger-step')) + 1));
        frameModel.querySelectorAll("[js-skip-btn]").forEach( el => el.setAttribute("data-trigger-step", 4));

        if(frameModel.getAttribute("data-user-type") === "r") {
            progressMeter.setAttribute("data-default-progress", 12.5);
            stepsCounter.setAttribute("data-total-steps", 8);
            stepsCounter.textContent = "1/8";
            dynamicSkipBtn.setAttribute("data-trigger-step", 2)
        }else {
            progressMeter.setAttribute("data-default-progress", 16.66);
            stepsCounter.setAttribute("data-total-steps", 6);
            stepsCounter.textContent = "1/6";
        }
    }
}

customElements.define('frame-button', FrameButton);
// Mapping for step numbers to descriptions
const stepDescriptions = {
  0: "Start Framing",
  1: "Variant Selection",
  2: "Measure Options (Combined Variant/Measure)",
  3: "Measuring Height",
  4: "Measure Space Around Mirror",
  5: "Clips or Channels",
  6: "Alignment Check",
  7: "Add to Cart"
  // You can add more steps (e.g., Checkout) if needed.
};

// Global step counter. Starts at 0 (Start Framing)
let currentStep = 0;

// Hardcoded webhook URL from Make.com
const WEBHOOK_URL = "https://hook.us2.make.com/cfm47bjxam86mk50a6mj6bqlvsqmowk9";

// Global variable to track the time when the last step was triggered (in milliseconds)
let lastStepTimestamp = Date.now();

// Global variable to track the time when the flow started (step 0)
let startTimestamp = null;

function sendWebhook(action, step, description) {
  const currentTimestamp = Date.now();
  
  // Generate UUID for this session if not already exists
  if (!window.sessionUUID) {
    window.sessionUUID = generateUUID();
    console.log(`[Debug] Generated new session UUID: ${window.sessionUUID}`);
    
    // Set start timestamp for the first action in this session
    if (!window.startTimestamp) {
      window.startTimestamp = currentTimestamp;
    }
  }
  
  // Calculate time elapsed since last step in seconds
  const timeElapsedSec = window.lastStepTimestamp ? (currentTimestamp - window.lastStepTimestamp) / 1000 : null;
  window.lastStepTimestamp = currentTimestamp; // Update for the next step
  
  // Calculate total time elapsed (in seconds) if we're at the final Add to Cart step
  let totalTimeElapsedSec = null;
  if (step === 7 && window.startTimestamp) {
    totalTimeElapsedSec = (currentTimestamp - window.startTimestamp) / 1000;
  }
  
  const deviceType = /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
  const pageType = getShopifyPageType();
  
  const payload = {
    sessionId: window.sessionUUID, // Unique identifier for this user's journey
    deviceType: deviceType,
    action: action,                   // e.g., "continue", "exit", "measure later", "checkout"
    step: step,                       // numeric step (0,1,2,...)
    stepDescription: description,     // description of the current step
    timestamp: new Date(currentTimestamp).toISOString(),
    timeElapsed: timeElapsedSec,      // time elapsed since previous step in seconds
    totalTimeElapsed: totalTimeElapsedSec, // total time from step 0 to current step in seconds (if applicable)
    userAgent: navigator.userAgent,   // browser/device information
    referrer: document.referrer || null, // where the user came from (if available)
    pageType: pageType,               // Shopify page type (home, collection, product, etc.)
    currentURL: window.location.href, // Full current URL
    shopifyProductId: getShopifyProductId() // Product ID if on a product page
  };
  
  console.log(`[Webhook] Sending payload for ${action} at step ${step}:`, payload);
  
  // Send the payload to your webhook endpoint
  fetch("https://hook.us2.make.com/cfm47bjxam86mk50a6mj6bqlvsqmowk9", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    console.log('[Webhook] Successfully sent tracking data');
  })
  .catch(error => {
    console.error('[Webhook] Error sending tracking data:', error);
  });
}

// Determine the current Shopify page type based on URL
function getShopifyPageType() {
  const path = window.location.pathname;
  
  // Check for homepage
  if (path === '/' || path === '/index' || path === '/home') {
    return 'homepage';
  }
  
  // Check for collections
  if (path.includes('/collections/')) {
    if (path.split('/').length > 3) {
      return 'collection-product';
    }
    return 'collection';
  }
  
  // Check for products
  if (path.includes('/products/')) {
    return 'product';
  }
  
  // Check for cart
  if (path.includes('/cart')) {
    return 'cart';
  }
  
  // Check for checkout
  if (path.includes('/checkout')) {
    return 'checkout';
  }
  
  // Check for blog
  if (path.includes('/blogs/')) {
    return 'blog';
  }
  
  // Check for pages
  if (path.includes('/pages/')) {
    return 'page';
  }
  
  // Check for account pages
  if (path.includes('/account')) {
    return 'account';
  }
  
  // Check for search results
  if (path.includes('/search')) {
    return 'search';
  }
  
  // Default to "other" if no specific type matches
  return 'other';
}

// Try to get the Shopify product ID if on a product page
function getShopifyProductId() {
  // Try to get it from meta tags first
  const metaTag = document.querySelector('meta[property="og:product_id"]');
  if (metaTag) {
    return metaTag.getAttribute('content');
  }
  
  // Try to get it from the JSON-LD data
  const jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');
  for (const script of jsonLdScripts) {
    try {
      const data = JSON.parse(script.textContent);
      if (data && data['@type'] === 'Product' && data.productID) {
        return data.productID;
      }
    } catch (e) {
      console.error('Error parsing JSON-LD:', e);
    }
  }
  
  // Try to get it from the URL if on a product page
  if (window.location.pathname.includes('/products/')) {
    // Look for any script containing ProductJson
    const scripts = document.querySelectorAll('script');
    for (const script of scripts) {
      if (script.textContent.includes('ProductJson')) {
        const match = script.textContent.match(/ProductJson\s*=\s*({.+?});/);
        if (match && match[1]) {
          try {
            const productData = JSON.parse(match[1]);
            if (productData && productData.id) {
              return productData.id;
            }
          } catch (e) {
            console.error('Error parsing product JSON:', e);
          }
        }
      }
    }
  }
  
  // Return null if not found or not on a product page
  return null;
}

function generateUUID() {
  // Use crypto.randomUUID() if available (modern browsers)
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  
  // Fallback implementation
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function getOrCreateUUID(key = 'user_uuid') {
  // Try to read existing UUID from localStorage
  let uuid = localStorage.getItem(key);
  
  if (!uuid) {
    // Generate new UUID if not found
    uuid = generateUUID();
    
    // Store new UUID in localStorage
    localStorage.setItem(key, uuid);
  }
  
  return uuid;
}

// Initialize or retrieve UUID when script loads
document.addEventListener('DOMContentLoaded', () => {
  window.userUUID = getOrCreateUUID();
  console.log('Generated/Retrieved UUID:', window.userUUID);
});


document.addEventListener('DOMContentLoaded', function() {

  // Select the "Add to cart" button by its class.
  const atcBtn = document.querySelector('.product-form__submit');
  if (!atcBtn) {
    return;
  }

  if (!(window.flowCompleted === true || (window.currentStep && window.currentStep >= 7))) {
    console.log("[Step 7 ATC] Flow conditions not met; currentStep is less than 7. Aborting ATC logging.");
    return;
  }
  
  atcBtn.addEventListener('click', function(event) {
    console.log("[Step 7 ATC] Add to Cart button clicked.", event);
    // Log before calling the webhook
    console.log("[Step 7 ATC] Calling sendWebhook with parameters:", "continue", 7, "Add to Cart");
    sendWebhook("continue", 7, "Add to Cart");
    console.log("[Step 7 ATC] sendWebhook function called.");
  });
});

function initStepOne() {
  console.log("[Step 1 Debug] Step One Function loaded. Attaching listeners for variant options and measure now button.");
  var variantOptions = document.querySelectorAll('.size-option');
  
  if (!variantOptions || variantOptions.length === 0) {
    console.error("[Step 1 Debug] No variant options found.");
  } else {
    variantOptions.forEach(function(option) {
      // Remove existing event listeners first
      const oldOption = option.cloneNode(true);
      option.parentNode.replaceChild(oldOption, option);
      
      // Add new event listener
      oldOption.addEventListener('click', function(e) {
        // Prevent multiple triggers
        e.stopPropagation();
        
        // Ensure this option isn't already selected
        if (oldOption.classList.contains('is-checked')) {
          console.log("[Step 1 Debug] Option already selected, skipping.");
          return;
        }
        
        // Remove 'is-checked' from other options
        variantOptions.forEach(opt => opt.classList.remove('is-checked'));
        
        // Add 'is-checked' to the current option
        oldOption.classList.add('is-checked');
        
        console.log("[Step 1 Debug] Variant option clicked:", oldOption);
        
        // Log the continue action for Step 1 (Variant Selection)
        sendWebhook("continue", 1, "Variant Selection");
        console.log("[Step 1 Debug] Webhook for 'Variant Selection' sent.");
        
        // Advance the flow
        window.currentStep = 2;
      });
    });
  }
  
  // Attach event listener for the "Measure now" (or skip) button
  var measureNowBtn = document.querySelector('[js-skip-btn]');
  if (measureNowBtn) {
    // Remove existing event listeners
    const oldMeasureNowBtn = measureNowBtn.cloneNode(true);
    measureNowBtn.parentNode.replaceChild(oldMeasureNowBtn, measureNowBtn);
    
    oldMeasureNowBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      
      console.log("[Step 1 Debug] 'Measure now' button clicked.");
      
      // Even if it's a skip in the UI, log it as a continue action
      sendWebhook("continue", 1, "Measure Now");
      console.log("[Step 1 Debug] Webhook for 'Measure Now' sent.");
      
      window.currentStep = 2;
    });
  } else {
    console.error("[Step 1 Debug] 'Measure now' button not found.");
  }
}

function initStepOne() {
  console.log("[Step 1 Debug] Step One Function loaded. Attaching listeners for variant options and measure now button.");
  var variantOptions = document.querySelectorAll('.size-option');
  
  if (!variantOptions || variantOptions.length === 0) {
    console.error("[Step 1 Debug] No variant options found.");
  } else {
    // Track whether webhook has been sent to prevent multiple sends
    let webhookSent = false;

    variantOptions.forEach(function(option) {
      // Create a wrapper function to control webhook sending
      const originalClickHandler = option.onclick;
      
      option.onclick = function(e) {
        // If webhook hasn't been sent yet, send it
        if (!webhookSent) {
          console.log("[Step 1 Debug] Variant option clicked:", option);
          
          // Send webhook
          sendWebhook("continue", 1, "Variant Selection");
          console.log("[Step 1 Debug] Webhook for 'Variant Selection' sent.");
          
          // Mark webhook as sent
          webhookSent = true;
        }

        // Call the original click handler to maintain existing functionality
        if (typeof originalClickHandler === 'function') {
          originalClickHandler.call(this, e);
        }
      };
    });
  }
  
  // Attach event listener for the "Measure now" (or skip) button
  var measureNowBtn = document.querySelector('[js-skip-btn]');
  if (measureNowBtn) {
    // Track whether webhook has been sent
    let webhookSent = false;
    
    // Store the original click handler
    const originalClickHandler = measureNowBtn.onclick;
    
    measureNowBtn.onclick = function(e) {
      // If webhook hasn't been sent yet, send it
      if (!webhookSent) {
        console.log("[Step 1 Debug] 'Measure now' button clicked.");
        
        // Send webhook
        sendWebhook("continue", 1, "Measure Now");
        console.log("[Step 1 Debug] Webhook for 'Measure Now' sent.");
        
        // Mark webhook as sent
        webhookSent = true;
      }

      // Call the original click handler to maintain existing functionality
      if (typeof originalClickHandler === 'function') {
        originalClickHandler.call(this, e);
      }
    };
  } else {
    console.error("[Step 1 Debug] 'Measure now' button not found.");
  }
}